import { Fragment, useContext, useEffect, useState } from "react";
import { acceptablePayments, footerLogo } from "../../assets/imageImport";
import { Link, useLocation } from "react-router-dom";
import { PAGES, PAGES_WITHOUT_FOOTER } from "../../routeConfig";
import { QuickOrderMain } from "../../View/QuickOrder/quickOrdSidePopup/QuickOrderMain";
import { fetchAppInfo, getAppInfo } from "../../utils/appInfo";
import { axiosInstance } from "../../axios/axiosInstance";
import { GlobalContext } from "../../Context/GlobalContext";
import { isValidArray } from "../Common/common";
import { useGuestClickGuard } from "../../Context/hook/useGuestClickGuard";
import { useAuth } from "../../Context/AuthContext";
import { usePageLocation } from "../../View/ProductHybrid/productPageOverlay/productPageOverlayContext";
export const BottomLayout = () => {
  const location = useLocation();
  const pageLocation = usePageLocation();
  const handleGuestClick = useGuestClickGuard();
  const { isAuthenticated } = useAuth();
  const isGuest = isAuthenticated === false;
  const [isNotRequired, setIsNotRequired] = useState(false);
  const { CategoryMenu } = useContext(GlobalContext);
  const [categoryList, setCategoryList] = useState(null);
  const [info, setInfo] = useState(null);
  useEffect(() => {
    const exists = PAGES_WITHOUT_FOOTER.some((item) => item.toLowerCase() == location.pathname.toLowerCase());
    setIsNotRequired(exists);
  }, [location]);

  useEffect(() => {
    if (isValidArray(CategoryMenu)) {
      var item = CategoryMenu.filter((item) => item.categoryId !== "WES-CLR").sort((a, b) =>
        a.categoryName.localeCompare(b.categoryName, undefined, { sensitivity: "base" }),
      );
      setCategoryList(item);
    }
  }, [CategoryMenu]);

  useEffect(() => {
    axiosInstance
      .get("AppInfo/GetInfo")
      .then((res) => {
        const data = typeof res?.data === "object" && res.data !== null ? res.data : {};
        var currentInfo = {
          node: String(data.node ?? "").trim(),
          version: String(data.version ?? "").trim(),
        };
        setInfo(currentInfo);
      })
      .catch(() => setInfo(null));
  }, [pageLocation.key]);

  if (!isNotRequired) {
    return (
      <Fragment>
        <footer className="footer-section">
          <div className="container-fluid container-lg">
            <div className="row mt-4 footer-link-top">
              <div className="col-lg-4">
                <div className="company-info">
                  <img src={footerLogo} alt="footer-logo" />
                  <p className="text-white mt-3">
                    WES is your trusted supplier for all your Audio/Visual, Data, Security, and Electronic Components
                    Parts, and Accessories needs We provide our customers with a comprehensive range of products and
                    fast reliable services to meet your project requirements. From professional installers and system
                    integrators to electronics and technicians, we have the right solutions for you!
                  </p>
                </div>
              </div>
              <div className="col-lg-8">
                <div className="row footer-links mt-md-3 mt-lg-0">
                  <div className="col-md-4 col-lg-4 mt-3 mt-lg-0">
                    <h5>Quick Links</h5>
                    <ul>
                      <li>
                        <Link to="/contactus">
                          <i className="fa-solid fa-circle" />
                          Contact Us
                        </Link>
                      </li>
                      <li>
                        {/* <Link to="/aboutus">
                          <i className="fa-solid fa-circle" />
                          About Us
                        </Link> */}
                        <Link to={PAGES.FAQ}>
                          <i className="fa-solid fa-circle" />
                          Help
                        </Link>
                      </li>
                      <li onClickCapture={handleGuestClick}>
                        <Link to="/myaccount">
                          <i className="fa-solid fa-circle" /> My Account
                        </Link>
                      </li>
                      <li onClickCapture={handleGuestClick}>
                        <Link
                          role="button"
                          data-bs-toggle={isGuest ? undefined : "offcanvas"}
                          data-bs-target={isGuest ? undefined : "#quickOrder-popup"}
                          aria-controls={isGuest ? undefined : "offcanvasRight"}
                        >
                          <i className="fa-solid fa-circle" style={{ fontSize: "5px", marginRight: "10px" }} /> Quick
                          Order
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <div className="col-md-4 col-lg-4 footer-links mt-3 mt-lg-0">
                    <h5>Others</h5>
                    <ul>
                      <li>
                        <Link to="/online-catalogue">
                          <i className="fa-solid fa-circle" />
                          Catalogue Download
                        </Link>
                      </li>
                      <li>
                        <Link to="/termsandconditions">
                          <i className="fa-solid fa-circle" />
                          Terms and Conditions
                        </Link>
                      </li>
                      <li>
                        <Link to="/jobenquiries">
                          <i className="fa-solid fa-circle" />
                          Job Enquiries
                        </Link>
                      </li>
                      <li>
                        <Link to="/privacypolicy">
                          <i className="fa-solid fa-circle" />
                          Privacy Policy
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <div className="col-md-4 col-lg-4 footer-links mt-3 mt-lg-0 d-none">
                    <h5>Users</h5>
                    <ul>
                      <li>
                        <Link to="/paymentpolicy">
                          <i className="fa-solid fa-circle" /> Payment Policy
                        </Link>
                      </li>
                      <li>
                        <Link to="/userguide">
                          <i className="fa-solid fa-circle" />
                          User Guide
                        </Link>
                      </li>
                      {/*<li>*/}
                      {/*  <Link to="/jobenquiries">*/}
                      {/*    <i className="fa-solid fa-circle" />*/}
                      {/*    Job Enquiries*/}
                      {/*  </Link>*/}
                      {/*</li>*/}
                      <li>
                        <Link to="/faq">
                          <i className="fa-solid fa-circle" />
                          FAQ
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                {categoryList && isValidArray(categoryList) && (
                  <div className="row footer-links mt-3 mt-lg-4" onClickCapture={handleGuestClick}>
                    <div className="container">
                      <h5>Categories</h5>
                      <ul className="row" style={{ display: "flex", flexWrap: "balance" }}>
                        {categoryList.map((item, index) => (
                          <li
                            key={`footer-category-${item.categoryId}`}
                            className="col-lg-4 col-sm-12 col-xs-12 col-md-4"
                            style={{ margin: "5px 0px", padding: "0px" }}
                          >
                            <Link to={item.url}>
                              <i className="fa-solid fa-circle" /> {item.categoryName}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="row payments-links">
              <div className="col-md-6 col-lg-6">
                <img src={acceptablePayments} alt="acceptable-payments" />
              </div>
              <div className="col-md-6 col-lg-6">
                <div className="social-links">
                  <ul>
                    <li>
                      <a href="#" title="Facebook">
                        <i className="fa-brands fa-facebook-f" />
                      </a>
                    </li>
                    <li>
                      <a href="#" title="Twitter">
                        <i className="fa-brands fa-x-twitter" />
                      </a>
                    </li>
                    <li>
                      <a href="#" title="Google Plus">
                        <i className="fa-brands fa-linkedin-in" />
                      </a>
                    </li>
                    <li>
                      <a href="#" title="Youtube">
                        <i className="fa-brands fa-youtube" />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="row copyrights">
              <div className="col-lg-6">
                <p className="mb-1">Copyright © wes.com.au. All rights are reserved.</p>
                {info && (
                  <p>
                    {info.version ? `v${info.version} ` : ""}
                    {info.node ? <span className="served-by-node">({info.node})</span> : null}
                  </p>
                )}
              </div>
              <div className="col-lg-6">
                <div className="help-links">
                  <ul>
                    <li>
                      <Link to="/faq">Help Center</Link>
                    </li>
                    <li>
                      <Link to="/faq">FAQ</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </footer>
        <QuickOrderMain />
      </Fragment>
    );
  }
};
